﻿$.fn.dxCtrlSondageQuestionTextBox = function custom_dxCtrlSondageQuestionTextBox(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsondagequestiontextbox dx-ctrl");
        this.createInstance(new cdxCtrlSondageQuestionTextBox(this, option));
    }
    return this;
}

window.cdxCtrlSondageQuestionTextBox = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        if (typeof option.dataQuestion.saisie_obligatoire == 'undefined') option.dataQuestion.saisie_obligatoire = false

        //$("<div style='font-size:140%;'/>").appendTo(container).html("Saisie libre pour le répondeur")
        $("<div style='font-style:italic;font-size:80%;'/>").appendTo(container).html("Met à disposition du répondeur une zone de texte libre ou il peut faire des remarques et préciser des demandes.")


        var $Table = $("<table style='width:100%;margin-top:20px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)

        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        $("<div>Saisie obligatoire:</div>").appendTo($Td)
        var $Td = $("<td style='width:200px;'/>").appendTo($Tr)
        $("<div style='margin:5px 0;display:inline-block;'/>").appendTo($Td).dxCheckBox({
            value: option.dataQuestion.saisie_obligatoire,
            onValueChanged: function (e) {
                option.dataQuestion.saisie_obligatoire = e.value
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            }
        }).dxCtrlNumberBox("instance")


        if (option.dataQuestion.id_page == -1) {
            if (typeof option.dataQuestion.tx_satisfaction_min == 'undefined') option.dataQuestion.tx_satisfaction_min = 0
            if (typeof option.dataQuestion.tx_satisfaction_max == 'undefined') option.dataQuestion.tx_satisfaction_max = 100
            //on est sur la page de fin
            //on peut configurer un taux de satisfaction
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;' colspan='2'/>").appendTo($Tr)
            $("<div style='margin-top:8px;'>Indiquez le taux de satisfaction minimum et maximum requis pour afficher cette question. Le taux est calculé à partir de l'ensemble des réponses aux questions des pages précédentes. Si le taux obtenu est inférieur au minimum ou supérieur au maximum, la question ne sera pas affichée.</div>").appendTo($Td)
            $("<div/>").appendTo($Td).dxRangeSlider({
                min: 0,
                max: 100,
                start: option.dataQuestion.tx_satisfaction_min,
                end: option.dataQuestion.tx_satisfaction_max,
                step: 1,
                tooltip: {
                    enabled: true,
                    format(value) {
                        return `${value}%`;
                    },
                    showMode: 'always',
                    position: 'bottom',
                },
                onValueChanged: function (e) {
                    option.dataQuestion.tx_satisfaction_min = e.start
                    option.dataQuestion.tx_satisfaction_max = e.end
                    option.sondage.mSave()
                    if (option.onValueChanged) option.onValueChanged()
                }
            });
        }


        $("<div style='margin-top:20px;'/>").appendTo(container).dxCtrlHtmlEditorSimple({
            labelMode: "floating",
            label: "Texte d'introduction à la saisie libre",
            value: option.dataQuestion.text_intro,
            onValueChanged: function (e) {
                option.dataQuestion.text_intro = (e.value == null ? "" : e.value)
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}